import { React, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Header from "./header";
import { Styles } from "./styles";
import MainDetails from "./main-details";
import Contacts from "./contacts";
import LogoSelect from "./logo-select";
import { Container, LinearProgress } from "@mui/material";
import {
  errorToaster,
  successToaster,
} from "../../../helper/toasterConfiguration";
import { api_Routes } from "../../../tools/api_Routes";
import { Helper } from "../../../tools/Helper";
import { useNavigate } from "react-router-dom";
import SliderSelect from "./slider-select";

const AddPanelForm = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(true);
  const [uploadOption, setUploadOption] = useState("logo");
  const [uploadSliderOption, setUploadSliderOption] = useState("uploadImages");
  const [currencies, setCurrencies] = useState([]);

  const [selectedFont, setSelectedFont] = useState("Mockads");
  const [selectedColor, setSelectedColor] = useState("#EBF2FF");
  const [selectedBgColor, setSelectedBgColor] = useState("#004571");
  const [logoName, setLogoName] = useState("LOREM");
  const [fontSize, setFontSize] = useState(25);
  const [inputValue, setInputValue] = useState("");
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [countries, setCountries] = useState([]);
  const [formData, setFormData] = useState({
    smmpanel_name: "",
    smmpanel_loginuser: "",
    smmpanel_login_password: "",
    service_type: "HTML",
    smmpanel_api_key: "",
    smmpanel_api_url: "",
    smmpanel_ticket_numper: "",
    smmpanel_date_of_ticket: "",
    smmpanel_url: "",
    description: "",
    smmpanel_email: "",
    smmpanel_instagram: "",
    smmpanel_skybe: "",
    smmpanel_telegram: "",
    smmpanel_fb: "",
    smmpanel_twitter: "",
    smmpanel_whatsapp: "",
    smmpanel_tel1: "",
    customLogo: "",
    logo: null,
    smmpanel_notice: "",
    url_service: "",
    trust: 0,
    order: null,
    country_id: "",
    paymentMethod: [],
    logo_bg_color: "",
    currency: "USD",
  });

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleCoursesChange = (event, value) => {
    setFormData((prev) => ({
      ...prev,
      country_id: value ? value?.id : "",
    }));
  };

  const getCountries = async () => {
    const { response } = await Helper.Get({
      url: api_Routes.Countries.View,
      hasToken: true,
    });
    if (response) {
      setCountries(response);
    }
  };

  const getCurrencies = async () => {
    try {
      const response = await fetch("https://api.frankfurter.dev/v1/latest?base=usd");
      const data = await response.json();

      // Create a Set to avoid duplicates
      const allCurrencies = new Set([
        data.base,  // Add the base currency (USD)
        ...Object.keys(data.rates)  // Add all currency codes from rates
      ]);

      // Convert Set to array and sort alphabetically
      const sortedCurrencies = Array.from(allCurrencies).sort();

      setCurrencies(sortedCurrencies);
    } catch (error) {
      console.error("Error fetching currencies:", error);
      // Fallback to USD if API fails
      setCurrencies(["USD"]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      try {
        await Promise.all([getCountries(), getCurrencies()]);
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredFields = ["smmpanel_url", "currency"];

    const updatedFormData = {
      ...formData,
    };

    const missingFields = requiredFields.filter(
        (field) => !updatedFormData[field]
    );

    if (uploadSliderOption === "enterUrls") {
      if (
          !updatedFormData.screenshot_urls ||
          updatedFormData.screenshot_urls.length === 0
      ) {
        updatedFormData.screenshot_urls =
            formData.smmpanel_url?.split(",").map((url) => url.trim()) || [];
      }
    } else if (uploadSliderOption === "uploadImages") {
      if (!updatedFormData.photos || updatedFormData.photos.length === 0) {
        updatedFormData.screenshot_urls =
            formData.smmpanel_url?.split(",").map((url) => url.trim()) || [];
      }
    }

    if (missingFields.length > 0) {
      errorToaster(
          `Please fill in all required fields: ${missingFields.join(", ")}`
      );
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const form_data = new FormData();

    if (uploadOption === "logo" && formData.logo) {
      form_data.append("logo", formData.logo);
    } else if (uploadOption === "customLogo") {
      updatedFormData.customLogo = {
        fontSize: `${fontSize}px`,
        color: selectedColor,
        fontFamily: selectedFont,
        logoName: logoName,
      };
      Object.keys(updatedFormData.customLogo).forEach((key) => {
        form_data.append(`customLogo[${key}]`, updatedFormData.customLogo[key]);
      });
    }

    form_data.append("logo_bg_color", selectedBgColor);
    Object.keys(updatedFormData).forEach((key) => {
      const value = updatedFormData[key];
      if (value && key !== "logo" && key !== "customLogo") {
        if (key === "screenshot_urls") {
          if (value.length > 0) {
            value.forEach((url, index) => {
              form_data.append(`screenshot_urls[${index}]`, url);
            });
          } else {
            form_data.append("screenshot_urls", "");
          }
        } else if (key === "photos" && uploadSliderOption === "uploadImages") {
          if (value.length > 0) {
            value.forEach((photo, index) => {
              form_data.append(`photos[${index}]`, photo);
            });
          }
        } else {
          form_data.append(key, value);
        }
      }
    });
    paymentMethod.forEach((method, index) => {
      form_data.append(`paymentMethod[${index}]`, method);
    });
    const result = await Helper.Post({
      url: api_Routes.Panels.Add,
      data: form_data,
      hasToken: true,
    });

    const { response, message } = result || {};

    if (response) {
      successToaster(message);
      navigate("/panels");
    } else {
      let errorMessage = "";
      if (typeof message === "string") {
        errorMessage = message;
      } else if (typeof message === "object") {
        errorMessage = Object.values(message).flat().join(", ");
      }
      errorToaster(errorMessage || "Faild to Store Panel");
      setIsLoading(false);
    }
  };

  return (
      <Styles>
        <Container>
          <Header />
          {loader ? (
              <LinearProgress className="mt-3" />
          ) : (
              <form onSubmit={handleSubmit} className="main-container">
                <div className="data-container">
                  <MainDetails
                      handleChange={handleChange}
                      formData={formData}
                      countries={countries}
                      currencies={currencies}
                      handleCoursesChange={handleCoursesChange}
                  />
                  <Contacts
                      handleChange={handleChange}
                      paymentMethod={paymentMethod}
                      setFormData={setFormData}
                      setPaymentMethod={setPaymentMethod}
                      inputValue={inputValue}
                      setInputValue={setInputValue}
                      formData={formData}
                  />
                </div>
                <LogoSelect
                    formData={formData}
                    setFormData={setFormData}
                    uploadOption={uploadOption}
                    setUploadOption={setUploadOption}
                    logoName={logoName}
                    setLogoName={setLogoName}
                    selectedFont={selectedFont}
                    setSelectedFont={setSelectedFont}
                    selectedColor={selectedColor}
                    setSelectedColor={setSelectedColor}
                    selectedBgColor={selectedBgColor}
                    setSelectedBgColor={setSelectedBgColor}
                    fontSize={fontSize}
                    setFontSize={setFontSize}
                />
                <SliderSelect
                    formData={formData}
                    setFormData={setFormData}
                    uploadOption={uploadSliderOption}
                    setUploadOption={setUploadSliderOption}
                />
                <div className="submit-btn">
                  <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={isLoading}
                  >
                    {isLoading ? (
                        <CircularProgress size={22} sx={{ color: "white" }} />
                    ) : (
                        "Submit"
                    )}
                  </Button>
                </div>
              </form>
          )}
        </Container>
      </Styles>
  );
};

export default AddPanelForm;